module.exports = __webpack_public_path__ + "static/media/SH 2.90ab5f84.mp3";